var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviewTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160,
    height: 90,
    viewBox: "0 0 160 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 90
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 90,
    fill: "#c7c7c8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40 11)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 78.25157928466797 67 L 1.748417019844055 67 L 40 1.972308874130249 L 78.25157928466797 67 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 40 3.944618225097656 L 3.496833801269531 66 L 76.50316619873047 66 L 40 3.944618225097656 M 40 0 L 80 68 L 0 68 L 40 0 Z",
    stroke: "none",
    fill: "#000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewTriangle);
export default __webpack_public_path__ + "static/media/preview_triangle.5d5d72bbb000407da58fb0587ad08251.svg";
export { ForwardRef as ReactComponent };